import { cdnPath } from 'slimSearch/constants';

const air1 = `${cdnPath}/deals/air1.png`;
const air2 = `${cdnPath}/deals/air2.png`;
const air3 = `${cdnPath}/deals/air3.png`;
const air4 = `${cdnPath}/deals/air4.png`;

const ocean1 = `${cdnPath}/deals/ocean1.png`;
const ocean2 = `${cdnPath}/deals/ocean2.png`;
const ocean3 = `${cdnPath}/deals/ocean3.png`;
const ocean4 = `${cdnPath}/deals/ocean4.png`;

const truck1 = `${cdnPath}/deals/truck1.png`;
const truck2 = `${cdnPath}/deals/truck2.png`;
const truck3 = `${cdnPath}/deals/truck3.png`;
const truck4 = `${cdnPath}/deals/truck4.png`;

export const DEALS_LIMIT = 8;

export const DEAL_IMAGES = {
  AIR: [air1, air2, air3, air4],
  EXPRESS: [air1, air2, air3, air4],
  LCL: [ocean1, ocean2, ocean3, ocean4],
  FCL: [ocean1, ocean2, ocean3, ocean4],
  FTL: [truck1, truck2, truck3, truck4],
  LTL: [truck1, truck2, truck3, truck4]
};
